/* eslint-disable no-console */
/* eslint-disable react/jsx-filename-extension */
import $ from 'jquery';
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';

/**
 * VSE-3895: POC for component-as-plugin to replace clipping view for broadcast assets
 *
 * This module was copied from app/views/media/videoEditorView.js then modified to only include code
 * required to mount/unmount the ClipperUi component provided by:
 *     https://gitlab.com/sinclair-digital/storyline/media-services/apps/clipper-ui
 */
const clipperUiView = Backbone.View.extend({
    initialize() {
        bindAllMethods(this);
    },
    render(model) {
        /*
         * FIX for NLP-1055: VDMS support has stated that there is no way to configure their API to return https
         * instead of http.  They did agree that we should be able to just use https interchangeably for this URL.
         * "After speaking with our engineering team we do not currently have a way change the url provided by the
         * API to https. But changing it to https for your workflow should cause no issues." Dan Rossin @ VDMS Support
         */
        // NOTE: mp4Url does not exist on legacyModel objects passed into this method, so we need to not break those.
        if (model.attributes?.mp4Url?.match?.call(/uplynk\.com/)) {
            model.attributes = {...model.attributes, mp4Url: model.attributes.mp4Url.replace('http://', 'https://')};
        }

        this.newModel = model;
        this.openVideoClippingView(model);
    },
    openVideoClippingView(legacyModel) {
        legacyModel.set('siteid', this.siteId);

        // get component from clipper-ui's last plugin deployment
        const Component = window.__sbgModules._baseModules.clipperUi?.provides?.Clipper;
        if (Component) {
            const videoModel = legacyModel.attributes.video ?? legacyModel.attributes;
            // BROADCAST: news broadcast
            // CLIP: all others video assets
            const assetType = legacyModel.attributes.mediaType === 'video' ? 'CLIP' : 'BROADCAST';
            ReactDOM.render(
                <Component
                    asset={videoModel}
                    assetType={assetType}
                    onClose={this._cancelBtnHandler}
                />,
                $('#clipper-ui-fly-over')[0],
            );

            // this.$el represents $(aside#clipper-ui-fly-over.sda-fly-over)
            this.$el.open();
        } else {
            throw new Error('failed to get component from plugin');
        }
    },
    _cancelBtnHandler(cancelBtnId) {
        this.$el.close();
        $('#' + cancelBtnId).off();
        ReactDOM.unmountComponentAtNode($('#clipper-ui-fly-over')[0]);

        return false;
    },
});

export default clipperUiView;
